import React from 'react';
import { motion } from 'framer-motion';
export function JoinSection() {
  return <section className="relative py-32 overflow-hidden" data-id="element-77">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-78">
        <img src="https://images.unsplash.com/photo-1445307906255-31afdd01bc4d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Forest path" className="w-full h-full object-cover" data-id="element-79" />
        <div className="absolute inset-0 bg-forest-900/80" data-id="element-80" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-82">
          <h2 className="text-4xl md:text-6xl font-serif text-white mb-6" data-id="element-83">
            The Trail is Calling
          </h2>
          <p className="text-xl text-earth-100 mb-10 max-w-2xl mx-auto font-light" data-id="element-84">
            Become a member of Fableworld today. Access exclusive routes, gear
            discounts, and a community that feels like home.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-85">
            <button className="bg-sunset-600 hover:bg-sunset-500 text-white px-8 py-4 rounded-full font-medium text-lg transition-colors duration-300 shadow-lg" data-id="element-86">
              Join Membership
            </button>
            <button className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-forest-900 px-8 py-4 rounded-full font-medium text-lg transition-colors duration-300" data-id="element-87">
              Gift a Membership
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}